import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GeoBlocker = ({ children }) => {
  const [geoStatus, setGeoStatus] = useState('checking'); // 'checking', 'allowed', 'blocked'
  const [country, setCountry] = useState('');

  useEffect(() => {
    const checkGeo = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/geo-check`);
        if (response.data.allowed) {
          setGeoStatus('allowed');
        } else {
          setGeoStatus('blocked');
          setCountry(response.data.country);
        }
      } catch (error) {
        // If geo check fails, allow access (fail open for better UX)
        console.warn('Geo check failed, allowing access');
        setGeoStatus('allowed');
      }
    };

    checkGeo();
  }, []);

  // Show loading while checking
  if (geoStatus === 'checking') {
    return (
      <div className="min-h-screen bg-[#14366C] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Show blocked message
  if (geoStatus === 'blocked') {
    return (
      <div className="min-h-screen bg-[#14366C] flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <div className="mb-6">
            <svg className="w-20 h-20 text-[#F58220] mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-white mb-4 font-oswald">
            Access Restricted
          </h1>
          <p className="text-gray-300 text-lg mb-6">
            We're sorry, but Bruce Nelson Plumbing & Heating services are only available to customers in the United States and Canada.
          </p>
          <p className="text-gray-400 text-sm">
            Your location: {country || 'Unknown'}
          </p>
          <div className="mt-8 pt-8 border-t border-gray-600">
            <p className="text-gray-400 text-sm">
              If you believe this is an error, please contact us at{' '}
              <a href="tel:651-738-9354" className="text-[#F58220] hover:underline">
                651-738-9354
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Allow access
  return children;
};

export default GeoBlocker;
